module.exports = __webpack_public_path__ + "img/sound-close.fcaee2b3.svg";